import React, { useState, useEffect } from "react";
import NavBar from "../../navbar/NavBar";
import { Box, Container, Fab, Fade } from "@mui/material";
import Footer from "../../footer/Footer";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

const CommonPage = (props) => {
	const { children } = props;
	const [isVisible, setIsVisible] = useState(false);

	const toggleVisibility = () => {
		if (window.scrollY > 300) {
			setIsVisible(true);
		} else {
			setIsVisible(false);
		}
	};

	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth"
		});
	};

	useEffect(() => {
		window.addEventListener("scroll", toggleVisibility);

		return () => {
			window.removeEventListener("scroll", toggleVisibility);
		};
	}, []);

	return (
		<>
		{/* <Box sx={{ minHeight: '1200px'}}> */}

		<Box>
			<NavBar />
			<Container sx={{ mt: 12, mb: 3 }}>
				<Container>
					{children}
				</Container>
			</Container>


			<Fade in={isVisible}>
				<Fab
					color="primary"
					aria-label="scroll back to top"
					onClick={scrollToTop}
					sx={{
						position: 'fixed',
						bottom: 32,
						left: 32,
					}}
				>
					<ArrowUpwardIcon />
				</Fab>
			</Fade>
		</Box>
		{/* <Box sx={{ backgroundColor: '#222222ff', color: 'white', py: 2 }}> */}
		<Box>
			<Footer />
		</Box>
		</>
	);
}

export default CommonPage;